import styled from "styled-components";
import { Wrapper } from "@googlemaps/react-wrapper";
import { useEffect, useState, useRef } from "react";
import MAPJSON from "../map.json";
import MAP1324JSON from "../map13-24.json";
import { Button, DatePicker, TimeRangePickerProps } from "antd";
import {
  CaretRightOutlined,
  FastBackwardOutlined,
  FastForwardOutlined,
  PauseOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import restSvg from "./restaurant.svg";
import lodgingSvg from "./lodging.svg";
import marketSvg from "./market.svg";
import cafeSvg from "./cafe.svg";
import toriiSvg from "./torii.svg";
import clothSvg from "./cloth.svg";
import dotSvg from "./dot.svg";
const mapArray = [...MAPJSON, ...MAP1324JSON];
dayjs.extend(utc);
const { RangePicker } = DatePicker;
const StyledDiv = styled.div`
  width: 98vw;
  height: 1000px;
`;

const Container = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  margin-top: -100px;
`;

const Time = styled.div`
  font-size: 40px;
  position: absolute;
  top: 160px;
  left: 40px;
  color: white;
  z-index: 100;
  padding: 40px;
  background-color: #162737;
  border-radius: 20px;
  font-family: "Righteous";
  color: #a7b1c0;
`;

const ControlPanel = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;
const marketCategory = ["grocery_or_supermarket", "supermarket"];
const tourismCategory = [
  "tourist_attraction",
  "point_of_interest",
  "travel_agency",
];
const storeCategory = [
  "store",
  "clothing_store",
  "jewelry_store",
  "shoe_store",
  "home_goods_store",
];
const restaurantCategory = [
  "food",
  "restaurant",
  "meal_delivery",
  "meal_takeaway",
];
const cafeCategory = ["cafe", "bakery"];
const getSvg = (category: string) => {
  if (marketCategory.includes(category)) {
    return marketSvg;
  } else if (category.includes("lodging")) {
    return lodgingSvg;
  } else if (restaurantCategory.includes(category)) {
    return restSvg;
  } else if (cafeCategory.includes(category)) {
    return cafeSvg;
  } else if (tourismCategory.includes(category)) {
    return toriiSvg;
  } else if (storeCategory.includes(category)) {
    return clothSvg;
  }
  return toriiSvg;
};
let show = false;
const TestMap = () => {
  const render = (status: string) => {
    return <div></div>;
  };

  const [pass, setPass] = useState(false);
  useEffect(() => {
    if (process.env.NODE_ENV !== "development") {
      // Function to verify the password

      const verifyPassword = () => {
        const enteredPassword = prompt("Please enter the password:");
        if (enteredPassword === "H1V3X") {
          setPass(true);
        } else if (enteredPassword === null || enteredPassword === "") {
        } else {
          alert("Incorrect password. Please try again ");
          verifyPassword();
        }
      };

      if (!show) {
        show = true;
        // Call the verifyPassword function when the component is first mounted
        verifyPassword();
      }
    } else {
      setPass(true);
    }
  }, []); // Empty dependency array means this effect will run once after the initial render
  return (
    <Container>
      {pass && (
        <Wrapper
          apiKey={"AIzaSyAX0LNEwep6-4dE55j7dakUe-67_jvNqo8"}
          render={render}
        >
          <MyMapComponent />
        </Wrapper>
      )}
    </Container>
  );
};
export default TestMap;

function MyMapComponent() {
  const ref = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<google.maps.Map>();
  const [showCategory, toogleShowCategory] = useState<boolean>(true);
  const [currenctTime, setCurrenctTime] = useState<number>(
    new Date("2023-10-02T00:00:00Z").getTime()
  );
  const [run, toogleRun] = useState<boolean>(true);

  const [currenctDate, setCurrenctDate] = useState<[string, string]>([
    "2023-10-02",
    "2023-10-03",
  ]);

  const markerRef = useRef<
    { commitTime: number; marker: google.maps.Marker }[]
  >([]);

  const startTimestamp = dayjs(`${currenctDate[0]}T00:00:00Z`).valueOf();
  const endTimestamp = dayjs(`${currenctDate[1]}T00:00:00Z`).valueOf();

  const onChange: TimeRangePickerProps["onChange"] = (date, dateString) => {
    toogleRun(false);
    setCurrenctDate(dateString);
    clear(dayjs(`${dateString[0]}T00:00:00Z`).valueOf());
  };

  useEffect(() => {
    if (map) {
      const filterItem = markerRef.current.filter(
        (el) =>
          el.commitTime > currenctTime && el.commitTime < currenctTime + 3600000
      );
      for (let item of filterItem) {
        item.marker.setMap(map);
      }
    }
  }, [map, currenctTime]);

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (run && currenctTime < endTimestamp) {
      timeout = setTimeout(() => {
        setCurrenctTime(currenctTime + 3600000);
      }, 1000);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [currenctTime, endTimestamp, run]); // Empty dependency array ensures that effect runs only once after initial render

  useEffect(() => {
    if (ref.current && !map) {
      const center = { lat: 35.652832, lng: 139.839478 };
      const zoom = 6;
      const temap = new window.google.maps.Map(ref.current, {
        center,
        zoom,
      });
      setMap(temap);
    }
  }, [map]);

  useEffect(() => {
    markerRef.current = mapArray.map((el) => ({
      commitTime: el.commitTime,
      marker: new google.maps.Marker({
        icon: { url: showCategory ? getSvg(el.category) : dotSvg },
        position: { lat: el.latitude, lng: el.longitude },
      }),
    }));
    return () => {
      markerRef.current.forEach((el) => {
        el.marker.setMap(null);
      });
    };
  }, [showCategory]);

  const clear = (time?: number) => {
    toogleRun(false);

    markerRef.current.forEach((el) => {
      el.marker.setMap(null);
    });
    setCurrenctTime(time || startTimestamp);
  };

  const showAll = () => {
    setCurrenctTime(endTimestamp);

    toogleRun(false);
    if (map) {
      markerRef.current
        .filter(
          (el) => el.commitTime > startTimestamp && el.commitTime < endTimestamp
        )
        .forEach((el) => {
          el.marker.setMap(map);
        });
    }
  };

  return (
    <div>
      <Time>
        {dayjs(currenctTime).utc().add(9, "hour").format("YYYY/MM/DD hh A JST")}
      </Time>
      <ControlPanel>
        <RangePicker
          onChange={onChange}
          defaultValue={[dayjs("2023-10-02"), dayjs("2023-10-03")]}
          disabledDate={(day) => {
            return (
              day.isBefore(dayjs("2023-10-02")) ||
              day.isAfter(dayjs("2023-10-24"))
            );
          }}
          allowClear={false}
        />

        <Button
          type="primary"
          shape="round"
          style={{ marginLeft: 10 }}
          icon={<FastBackwardOutlined />}
          onClick={() => clear()}
        />
        <Button
          type="primary"
          shape="round"
          icon={run ? <PauseOutlined /> : <CaretRightOutlined />}
          onClick={() => {
            toogleRun(!run);
          }}
        />
        <Button
          type="primary"
          shape="round"
          icon={<FastForwardOutlined />}
          onClick={showAll}
        />
        <Button
          shape="round"
          onClick={() => {
            toogleShowCategory(!showCategory);
          }}
        >
          {showCategory ? "Show Dot" : "Show Cateogry"}
        </Button>
      </ControlPanel>

      <StyledDiv ref={ref} id="map" />
    </div>
  );
}
